import { useAuth } from "../contexts/AuthContext";
import { FeatureLevel } from "../auth/featureScopes";

interface PricingAccess {
  level: FeatureLevel;
  canViewPrices: boolean;
  canEditPrices: boolean;
}

/**
 * Vehicle purchase price visibility, driven by the role's pricing scope.
 * Falls back to full access whenever scopes are missing — they are undefined
 * while auth loads, and defaulting to hidden would blink prices off for
 * everyone on every page load.
 */
export default function usePricingAccess(): PricingAccess {
  const { featureScopes } = useAuth();
  const level = featureScopes?.pricing ?? 2;

  return {
    level,
    canViewPrices: level >= 1,
    canEditPrices: level >= 2,
  };
}
